import React from 'react';
import { useLeagueSelection } from '../../../../hooks/useLeagueSelection';
import clubInfo from "../../../../static/clubInfo";
import { getTeamLogo } from '../../../../static/logos/TeamLogos';
import {NavLink} from "react-router-dom";
import { MoonLoader } from 'react-spinners';
import './Table.css';

const LeagueStandingsTable = ({ title, data, isLoadingTables }) => {
    const {leagueLevel} = useLeagueSelection();
    const Standings = data;
    if (isLoadingTables) {
        return <MoonLoader color="#36d7b7" size={50} />;
    }
    return (
        <div className={`standings-table ${leagueLevel === '1' ? "standings-table-first": leagueLevel === '2' ? "standings-table-second":""}`}>

                <NavLink to={'/tabelle'}>
            <table className="standings-table__content">
                <thead>
                    <tr>
                        <td>{title}</td>
                    </tr>
                </thead>
                <tbody>
                {Standings.map((team) => (
                    <tr key={team.club}>
                        <td></td>
                        <td>{team.standing}</td>
                        <td>
                            <img src={getTeamLogo(team.club)} alt={team.club}/>
                        </td>
                        <td>
                            <span>
                                {clubInfo.find(club => club.clubee_name === team.club)?.details.club_short}
                            </span>
                        </td>
                        <td>{team.points}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            </NavLink>
        </div>
    );
};

export default LeagueStandingsTable;
